import { motion } from 'framer-motion';
import styled from 'styled-components';

import { layout } from 'utils/styles/theme';

export const SnapToCursorWrapper = styled.div`
  position: relative;
  width: fit-content;
`;

export interface HoverElementProps {
  overlay?: boolean;
}
export const HoverElement = styled(motion.div)<HoverElementProps>`
  position: absolute;
  inset: 0;

  z-index: ${({ overlay }) => overlay && layout.zIndex.overContent};

  pointer-events: none;
`;
